import { useEffect } from "react";
import PropTypes from "prop-types";
import { createPortal } from "react-dom";
import { RefShape } from "venuescanner-js/react/components/Srp/shapes";

const PinnedElement = ({ pinTo, children, matchWidth }) => {
  const el = document.createElement("div");
  Object.entries({
    position: "absolute",
    "z-index": 9999,
    "will-change": "left, top",
  }).forEach(([k, v]) => el.style.setProperty(k, v));

  const fixPosition = () => {
    if (pinTo && pinTo.current) {
      const pinToRect = pinTo.current.getBoundingClientRect();
      el.style.setProperty(
        "top",
        `${pinToRect.bottom + document.documentElement.scrollTop}px`
      );
      el.style.setProperty("left", `${pinToRect.left}px`);
      el.style.setProperty("right", 0);
      if (matchWidth) el.style.setProperty("width", `${pinToRect.width}px`);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", fixPosition);

    return () => {
      window.addEventListener("scroll", fixPosition);
    };
  });

  useEffect(() => {
    document.body.appendChild(el);

    return () => {
      document.body.removeChild(el);
    };
  });

  fixPosition();

  return createPortal(children, el);
};

PinnedElement.propTypes = {
  pinTo: RefShape.isRequired,
  children: PropTypes.node.isRequired,
  matchWidth: PropTypes.bool,
};

PinnedElement.defaultProps = {
  matchWidth: false,
};

export default PinnedElement;
